/**
 * Google API
 * Google Drive and Gmail integration for CRM
 */

import { crmPost, crmPut, crmDelete } from './crmConfig';

// ─── Gmail ────────────────────────────────────────────────────────────────────

/**
 * Send email via Gmail
 * @param {FormData} formData - Multipart form data with email details
 */
export const sendEmail = async (formData) => {
  const response = await crmPost('/api/google/gmail/send/new', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// ─── Drive Attachments ────────────────────────────────────────────────────────

/**
 * Upload attachment to lead
 * @param {string} leadId - Lead ID
 * @param {FormData} formData - Multipart form data with file
 */
export const uploadAttachment = async (leadId, formData) => {
  const response = await crmPost(`/api/google/leads/${leadId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

/**
 * Update attachment name
 * @param {Object} data - { leadId, fileId, newName }
 */
export const renameAttachment = async (data) => {
  const response = await crmPut('/api/google/leads/attachments/name', data);
  return response.data;
};

/**
 * Replace lead attachment
 * @param {string} leadId - Lead ID
 * @param {FormData} formData - Multipart form data with new file and fileId
 */
export const replaceLeadAttachment = async (leadId, formData) => {
  const response = await crmPut(`/api/google/leads/${leadId}/attachments/replace`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

/**
 * Delete lead attachment
 * @param {string} leadId - Lead ID
 * @param {string} fileId - Google Drive file ID
 */
export const deleteAttachment = async (leadId, fileId) => {
  const response = await crmDelete(`/api/google/leads/${leadId}/attachments/${fileId}`);
  return response.data;
};
